import { Typography } from '@/components/Typography';
import { useAlertDialog } from '@/shared/context/AlertDialogContext';
import { useAuth } from '@/shared/provider/AuthProvider';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';

interface FeedCardProps {
	image: string;
	content: string;
	postId?: number;
}

const FeedCard = ({ image, content, postId }: FeedCardProps) => {
	const { showAlert, closeAlert } = useAlertDialog();
	const { userInfo } = useAuth();
	const navigate = useNavigate();

	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold: 0.1,
	});

	const handleRedirectApp = () => {
		window.location.href = `https://angkorlife.onelink.me/MIbi/?id=${userInfo?.token}&angkorPost=${postId}`;
	};

	const handleNavigate = () => {
		if (userInfo) {
			showAlert({
				logo: true,
				title: 'Experience AngkorLife in the app!',
				description:
					'Enjoy even more content and features when you use the app.',
				actionText: 'Continue in App',
				onConfirm: () => {
					handleRedirectApp();
					closeAlert();
				},
				hasSecondaryModal: true,
			});
		} else {
			showAlert({
				logo: false,
				title: 'Would you like to log in?',
				actionText: 'Log in',
				cancelText: 'Cancel',
				onConfirm: () => navigate('/login'),
				onCancel: () => closeAlert(),
			});
		}
	};

	return (
		<button onClick={handleNavigate} className="flex flex-col gap-1">
			<div className="w-full h-25" ref={ref}>
				{inView && (
					<img
						loading="lazy"
						src={image}
						alt=""
						className="object-cover object-[center_center] rounded-xl size-full"
					/>
				)}
			</div>
			<Typography variant="body-small" className="line-clamp-2 text-start">
				{content}
			</Typography>
		</button>
	);
};

export default FeedCard;
